import { render, staticRenderFns } from "./BoutonAjoutProduit.vue?vue&type=template&id=d59cb1c2&"
import script from "./BoutonAjoutProduit.vue?vue&type=script&lang=js&"
export * from "./BoutonAjoutProduit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d59cb1c2')) {
      api.createRecord('d59cb1c2', component.options)
    } else {
      api.reload('d59cb1c2', component.options)
    }
    module.hot.accept("./BoutonAjoutProduit.vue?vue&type=template&id=d59cb1c2&", function () {
      api.rerender('d59cb1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuiviCommandes/BoutonAjoutProduit.vue"
export default component.exports